import { render, staticRenderFns } from "./MedecinDetailTuteurcreate.vue?vue&type=template&id=492b8a26&"
import script from "./MedecinDetailTuteurcreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailTuteurcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports